import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
// import commonUtil from '../../utils/commonUtil';
import pdfUtil from '../../utils/PDFUtil';
import ApplyCSS from '../ApplyCSS';

class PrintWindow extends Component {
  componentDidMount() {
    if (document) {
      const openerContainer = this.renderHTML();
      if (openerContainer) {
        document.querySelector('#printContent').classList.value = openerContainer.classList.value;
        document.querySelector('#printContent').innerHTML = openerContainer.innerHTML;
        document.querySelectorAll('#printContent .exclude-for-print-download').forEach((element) => {
          element.classList.add('display-none');
        });
        setTimeout(() => {
          window.print();
          window.setTimeout(pdfUtil.contentPrintedCallback, 500);
        }, 500);
      }
    }
  }

  renderHTML = () => {
    if (typeof document !== 'undefined' && window.opener !== null) {
      const elementSelector = window.opener.document.querySelector('#divPrint');
      return elementSelector;
    }
    return undefined;
  }

  render() {
    let settingCSS = {};
    if (typeof window !== 'undefined' && (window.location.pathname.indexOf('tableOrganizer') > -1 || window.location.pathname.indexOf('gestiondemesa') > -1)) {
      settingCSS = { width: 'auto' };
    }
    return (
      <React.Fragment>
        <ApplyCSS pageName={this.props.pageName || this.props.params.pageName} />
        <div id="printContent" style={settingCSS} />
      </React.Fragment>
    );
  }
}

export default PrintWindow;
